import { Spinner } from "@mylaunch/components/ui"
import { TitleHeader } from "~/components/title-header"

export default function PageLoading({ noHeader }: { noHeader?: boolean }) {
  return (
    <div className="flex flex-col h-dvh">
      {!noHeader && <TitleHeader />}
      <div className="flex flex-1 items-center justify-center">
        <Spinner className="size-12" />
      </div>
    </div>
  )
}
